import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import { ToastContainer, toast } from 'react-toastify'
import './i18n'
import { setAuthTokenProvider } from '@velocity/shared'
dayjs.extend(advancedFormat)
dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)

setAuthTokenProvider({
  storage: localStorage,
  source: 'web',
  development: process.env.NODE_ENV === 'development',
  options: {
    toast,
    GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY
  }
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <>
    <App />
    <ToastContainer
      position='top-center'
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme='colored'
    />
  </>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
